import { render, staticRenderFns } from "./network-transfer.vue?vue&type=template&id=049448be"
import script from "./network-transfer.vue?vue&type=script&lang=js"
export * from "./network-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports